import type { BookDownloadPayload } from '~/types/download'

export function isBookPayload(payload: unknown): payload is BookDownloadPayload {
  return Boolean(payload && typeof payload === 'object' && 'kind' in payload && payload.kind === 'book')
}
